import { adminApi } from "./adminApi";

export async function fetchAdminUsers() {
  const { data } = await adminApi.get("/admin/users");
  return data;
}

export async function createAdminUser({ email, password }) {
  const { data } = await adminApi.post("/admin/users", { email, password });
  return data;
}

export async function resetAdminPassword(userId, password) {
  const { data } = await adminApi.patch(`/admin/users/${userId}/password`, {
    password,
  });
  return data;
}

export async function deleteAdminUser(userId) {
  await adminApi.delete(`/admin/users/${userId}`);
}
